import React, { useState } from 'react';
import axios from 'axios';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { ConsentChecks, consentsValid } from './ConsentChecks';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ConsentGate() {
  const { user, refreshUser, logout } = useAuth();
  const [value, setValue] = useState({ terms_accepted: false, data_processing_accepted: false, marketing_consent: false });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  if (!user?.consent_required) return null;

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      await axios.post(`${API_URL}/api/auth/consents`, {
        terms: value.terms_accepted, data_processing: value.data_processing_accepted, marketing: value.marketing_consent,
      }, { withCredentials: true });
      await refreshUser();
    } catch {
      setError('Could not save your consent. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid="consent-gate">
      <div className="bg-zinc-950 border border-zinc-800 rounded-2xl p-6 md:p-8 max-w-lg w-full">
        <ShieldCheck className="w-8 h-8 text-[#C41E3A] mb-4" />
        <h2 className="text-2xl font-bold text-white mb-2">Before you continue</h2>
        <p className="text-zinc-400 text-sm mb-5">We need your consent to store and process your information under India's DPDP Act 2023 and the GDPR.</p>
        <ConsentChecks value={value} onChange={setValue} prefix="gate" />
        {error && <p className="text-red-400 text-sm mt-3">{error}</p>}
        <div className="flex gap-3 mt-6">
          <button type="button" onClick={logout} className="px-4 py-3 rounded-full border border-zinc-700 text-zinc-300 text-sm" data-testid="consent-gate-logout">Log out</button>
          <button
            type="button"
            onClick={save}
            disabled={!consentsValid(value) || saving}
            className="flex-1 bg-[#C41E3A] hover:bg-[#A01830] disabled:opacity-50 text-white py-3 rounded-full font-semibold"
            data-testid="consent-gate-submit"
          >
            {saving ? 'Saving...' : 'Agree and continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
